/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Entitychangelogdescription2Inputs */

const id_sandboxes_entitychangelogdescription2 = /** @type {(inputs: Sandboxes_Entitychangelogdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pembaruan yang dilacak`)
};

const ms_sandboxes_entitychangelogdescription2 = /** @type {(inputs: Sandboxes_Entitychangelogdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kemas kini yang dikesan`)
};

const da_sandboxes_entitychangelogdescription2 = /** @type {(inputs: Sandboxes_Entitychangelogdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sporede opdateringer`)
};

const de_sandboxes_entitychangelogdescription2 = /** @type {(inputs: Sandboxes_Entitychangelogdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verfolgte Aktualisierungen`)
};

const en_us2_sandboxes_entitychangelogdescription2 = /** @type {(inputs: Sandboxes_Entitychangelogdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tracked updates`)
};

const es_es2_sandboxes_entitychangelogdescription2 = /** @type {(inputs: Sandboxes_Entitychangelogdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizaciones rastreadas`)
};

const es_mx2_sandboxes_entitychangelogdescription2 = /** @type {(inputs: Sandboxes_Entitychangelogdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizaciones rastreadas`)
};

const fil_sandboxes_entitychangelogdescription2 = /** @type {(inputs: Sandboxes_Entitychangelogdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga na-track na update`)
};

const fr_sandboxes_entitychangelogdescription2 = /** @type {(inputs: Sandboxes_Entitychangelogdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifications suivies`)
};

const it_sandboxes_entitychangelogdescription2 = /** @type {(inputs: Sandboxes_Entitychangelogdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiornamenti tracciati`)
};

const hu_sandboxes_entitychangelogdescription2 = /** @type {(inputs: Sandboxes_Entitychangelogdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Követett frissítések`)
};

const nl_sandboxes_entitychangelogdescription2 = /** @type {(inputs: Sandboxes_Entitychangelogdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gevolgde updates`)
};

const no_sandboxes_entitychangelogdescription2 = /** @type {(inputs: Sandboxes_Entitychangelogdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sporbare oppdateringer`)
};

const pl_sandboxes_entitychangelogdescription2 = /** @type {(inputs: Sandboxes_Entitychangelogdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Śledzone aktualizacje`)
};

const pt_br2_sandboxes_entitychangelogdescription2 = /** @type {(inputs: Sandboxes_Entitychangelogdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualizações rastreadas`)
};

const pt_sandboxes_entitychangelogdescription2 = /** @type {(inputs: Sandboxes_Entitychangelogdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualizações registadas`)
};

const ro_sandboxes_entitychangelogdescription2 = /** @type {(inputs: Sandboxes_Entitychangelogdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizări urmărite`)
};

const fi_sandboxes_entitychangelogdescription2 = /** @type {(inputs: Sandboxes_Entitychangelogdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seuratut päivitykset`)
};

const sv_sandboxes_entitychangelogdescription2 = /** @type {(inputs: Sandboxes_Entitychangelogdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spårade uppdateringar`)
};

const vi_sandboxes_entitychangelogdescription2 = /** @type {(inputs: Sandboxes_Entitychangelogdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cập nhật được theo dõi`)
};

const tr_sandboxes_entitychangelogdescription2 = /** @type {(inputs: Sandboxes_Entitychangelogdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İzlenen güncellemeler`)
};

const cs_sandboxes_entitychangelogdescription2 = /** @type {(inputs: Sandboxes_Entitychangelogdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sledované aktualizace`)
};

const bg_sandboxes_entitychangelogdescription2 = /** @type {(inputs: Sandboxes_Entitychangelogdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проследени актуализации`)
};

const ru_sandboxes_entitychangelogdescription2 = /** @type {(inputs: Sandboxes_Entitychangelogdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отслеживаемые обновления`)
};

const uk_sandboxes_entitychangelogdescription2 = /** @type {(inputs: Sandboxes_Entitychangelogdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Відстежувані оновлення`)
};

const ar_sandboxes_entitychangelogdescription2 = /** @type {(inputs: Sandboxes_Entitychangelogdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التحديثات المتعقبة`)
};

const hi_sandboxes_entitychangelogdescription2 = /** @type {(inputs: Sandboxes_Entitychangelogdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ट्रैक किए गए अपडेट`)
};

const th_sandboxes_entitychangelogdescription2 = /** @type {(inputs: Sandboxes_Entitychangelogdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การอัปเดตที่ติดตาม`)
};

const ja_sandboxes_entitychangelogdescription2 = /** @type {(inputs: Sandboxes_Entitychangelogdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`追跡された更新`)
};

const zh_cn2_sandboxes_entitychangelogdescription2 = /** @type {(inputs: Sandboxes_Entitychangelogdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已追踪的更新`)
};

const zh_hant1_sandboxes_entitychangelogdescription2 = /** @type {(inputs: Sandboxes_Entitychangelogdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已追蹤的更新`)
};

const ko_sandboxes_entitychangelogdescription2 = /** @type {(inputs: Sandboxes_Entitychangelogdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`추적된 업데이트`)
};

/**
* | output |
* | --- |
* | "Tracked updates" |
*
* @param {Sandboxes_Entitychangelogdescription2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_entitychangelogdescription2 = /** @type {((inputs?: Sandboxes_Entitychangelogdescription2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Entitychangelogdescription2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_entitychangelogdescription2(inputs)
	if (locale === "ms") return ms_sandboxes_entitychangelogdescription2(inputs)
	if (locale === "da") return da_sandboxes_entitychangelogdescription2(inputs)
	if (locale === "de") return de_sandboxes_entitychangelogdescription2(inputs)
	if (locale === "en-US") return en_us2_sandboxes_entitychangelogdescription2(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_entitychangelogdescription2(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_entitychangelogdescription2(inputs)
	if (locale === "fil") return fil_sandboxes_entitychangelogdescription2(inputs)
	if (locale === "fr") return fr_sandboxes_entitychangelogdescription2(inputs)
	if (locale === "it") return it_sandboxes_entitychangelogdescription2(inputs)
	if (locale === "hu") return hu_sandboxes_entitychangelogdescription2(inputs)
	if (locale === "nl") return nl_sandboxes_entitychangelogdescription2(inputs)
	if (locale === "no") return no_sandboxes_entitychangelogdescription2(inputs)
	if (locale === "pl") return pl_sandboxes_entitychangelogdescription2(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_entitychangelogdescription2(inputs)
	if (locale === "pt") return pt_sandboxes_entitychangelogdescription2(inputs)
	if (locale === "ro") return ro_sandboxes_entitychangelogdescription2(inputs)
	if (locale === "fi") return fi_sandboxes_entitychangelogdescription2(inputs)
	if (locale === "sv") return sv_sandboxes_entitychangelogdescription2(inputs)
	if (locale === "vi") return vi_sandboxes_entitychangelogdescription2(inputs)
	if (locale === "tr") return tr_sandboxes_entitychangelogdescription2(inputs)
	if (locale === "cs") return cs_sandboxes_entitychangelogdescription2(inputs)
	if (locale === "bg") return bg_sandboxes_entitychangelogdescription2(inputs)
	if (locale === "ru") return ru_sandboxes_entitychangelogdescription2(inputs)
	if (locale === "uk") return uk_sandboxes_entitychangelogdescription2(inputs)
	if (locale === "ar") return ar_sandboxes_entitychangelogdescription2(inputs)
	if (locale === "hi") return hi_sandboxes_entitychangelogdescription2(inputs)
	if (locale === "th") return th_sandboxes_entitychangelogdescription2(inputs)
	if (locale === "ja") return ja_sandboxes_entitychangelogdescription2(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_entitychangelogdescription2(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_entitychangelogdescription2(inputs)
	return ko_sandboxes_entitychangelogdescription2(inputs)
});
export { sandboxes_entitychangelogdescription2 as "sandboxes.entityChangelogDescription" }